import { render, staticRenderFns } from "./StudySetDetails.vue?vue&type=template&id=3b737db8&scoped=true&"
import script from "./StudySetDetails.vue?vue&type=script&lang=js&"
export * from "./StudySetDetails.vue?vue&type=script&lang=js&"
import style0 from "./StudySetDetails.vue?vue&type=style&index=0&id=3b737db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b737db8",
  null
  
)

export default component.exports